import SignUp from 'components/pages/SignUp/SignUp';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('registration-login');

const IndexPage = SignUp;

export default buildPage(IndexPage, {
  skipSSR: true,
  metaData: {
    title: 'Registration',
    description: 'Please log in or sign up',
  },
  loggedInRedirect: '/dashboard',
});
